import { IPerformanceEvaluationStatus } from "models/PerformanceEvaluationStatusModel";
import { BaseService } from "./base.service";

class PerformanceEvaluationStatusServiceInternal extends BaseService {
	getPerformanceEvaluationStatusList = async (): Promise<
		IPerformanceEvaluationStatus[]
	> =>
		this.callApi<IPerformanceEvaluationStatus[]>(
			`PerformanceEvaluationStatus/GetAll`,
			"GET"
		);
}

export const PerformanceEvaluationStatusService =
	new PerformanceEvaluationStatusServiceInternal();
